import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import RepairOperationCreateUpdate, {
  RepairOperationCreateUpdateHandle,
  RepairOperationCreateUpdateProps,
} from "./RepairOperationCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: RepairOperationCreateUpdateProps;
}

export default function RepairOperationCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.repairOperationId });
  const formWrapperRef = useRef<RepairOperationCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} repair operation
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <RepairOperationCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
